import { Injectable, Signal, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { combineLatest, map } from 'rxjs';
import { USER_QUERIES } from '@/app/platform/platform-core/user/store/types';
import { hasFeature } from '@/app/support/support-access.service';
import { HdChartSettingsStore } from '../chart/bodygraph/chart-tabs/hd-chart-settings.store';
import { REVIEW_LINE_TEXTS_FEATURE_ID } from './hd-line-text-review.metadata';

/**
 * Toegang tot de review van de eigen lijnteksten: de UPAM-feature
 * `ReviewLineTexts` (per gebruikersgroep toegekend). De reviewknoppen staan
 * bovendien enkel bij teksten die zichtbaar zijn, dus samen met de setting
 * "eigen lijnteksten tonen" (zie {@link reviewVisible}).
 */
@Injectable({ providedIn: 'root' })
export class HdLineTextReviewAccessService {
  // Optioneel: component-specs zonder user-store hebben simpelweg geen toegang.
  private readonly userQueries = inject(USER_QUERIES, { optional: true });
  private readonly settings = inject(HdChartSettingsStore);

  /** UPAM-feature toegekend? */
  readonly featureGranted: Signal<boolean> = this.granted(REVIEW_LINE_TEXTS_FEATURE_ID);

  /** Feature én de eigen lijnteksten staan aan: dan zijn de reviewknoppen zinvol. */
  readonly reviewVisible = computed(() => this.featureGranted() && this.settings.ownLineTextsEnabled());

  private granted(featureId: string): Signal<boolean> {
    if (this.userQueries == null) {
      return computed(() => false);
    }
    return toSignal(
      combineLatest([this.userQueries.isAnyUserAuthenticated$, this.userQueries.availableApps$]).pipe(
        map(([authenticated, apps]) => authenticated && hasFeature(apps, featureId)),
      ),
      { initialValue: false },
    );
  }
}
